import type React from 'react';
import SessionPreview from '../atoms/SessionPreview';

export interface SessionContentProps extends React.HTMLAttributes<HTMLDivElement> {
  preview: string;
  children?: React.ReactNode;
}

export default function SessionContent({
  preview,
  children,
  className = '',
  ...props
}: SessionContentProps) {
  return (
    <div className={`${className}`} {...props}>
      <SessionPreview lines={2}>
        {preview}
      </SessionPreview>
      {children}
    </div>
  );
}